/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CompanyQueryResponse,
  GetApiV1CompanyQueryParams,
  GetApiV1Company400,
  GetApiV1Company401,
  GetApiV1Company500,
} from "../../types/companyListingController/GetApiV1Company.ts";

function getGetApiV1CompanyUrl() {
  const res = { method: "GET", url: `/api/v1/company` as const };
  return res;
}

/**
 * @description Retorna a lista paginada de empresas ativas, ordenadas por nome, para alimentar o dropdown de empresas. O filtro search compara com nome ou código, sem diferenciar maiúsculas de minúsculas, e companyId restringe o resultado a uma empresa. **(Requer Authorization para autenticação)**
 * @summary Listar empresas paginadas (Requer Authorization para autenticação)
 * {@link /api/v1/company}
 */
export async function getApiV1Company(
  params?: GetApiV1CompanyQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CompanyQueryResponse,
    ResponseErrorConfig<
      GetApiV1Company400 | GetApiV1Company401 | GetApiV1Company500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CompanyUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
